module.exports = {
    setVideoPosition: function (params) {
        if (!params.$iframe || !params.$container || !params.aspectRatio) return;

        var aspectRatio = params.aspectRatio;

        var sizes = params.$container[0].getBoundingClientRect();

        // размеры контейнера
        var cw = sizes.width;
        var ch = sizes.height;

        //дефолтные размеры ифрейма
        //var iw = cw;
        //var ih = ch;

        //смотрим размеры видимой области внутри самого видео (виртуальная сущность, потом надо будет на ее основе смотреть где расположены границы ифрейма)
        var vw, vh;

        //обрезать видео надо сверху-снизу
        if (cw / ch > aspectRatio) {
            vw = cw;
            vh = vw / aspectRatio;
        } else {
            //обрезать видео надо слева-справа
            vh = ch;
            vw = vh * aspectRatio;
        }

        //теперь расчитываем размеры ифрейма так, чтобы видимой области внутри самого видео была размером vw на vh
        //если у видео черные полосы идут сверху-снизу
        //if (aspect_poster < aspect_real) {
        //    iw = vw;
        //    ih = iw / aspectRatio;
        //} else {
        var ih = vh;
        var iw = ih * aspectRatio;
        //}

        //теперь мы знаем размеры ифрейма и нам надо просто спозиционировать его по центру области в которой нам предстоит его показывать (frame)
        var il = -(iw - cw) / 2;
        var it = -(ih - ch) / 2;

        //$iframe может быть массивом объектов, например постером и видео
        params.$iframe.css({
            position: 'absolute',
            left: il,
            top: it,
            width: iw + 1,
            height: ih + 1
        });
    }
};



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/utils/video.js
// module id = 194
// module chunks = 0